import { EnrollCourseMaster } from "./EnrollCourseMaster.model";
import { ExamMCQMaster } from "./ExamMCQMaster.model";
import { LookupData } from "./LookupData.model";
import { StudentMaster } from "./StudentMaster.model";

export class ExamMaster{
    public examMasterId: number;
    public marks: number;
    public totalMcq: number;
    public durationOfExam: number;
    public enrollCourseMaster: EnrollCourseMaster;
    public enrollCourseMasterId: number;
    public studentMaster: StudentMaster;
    public studentMasterId: number;
    public isDelete: string;
    public examResultFilePath: string;
    public examMCQMasterList: ExamMCQMaster[];
    public examMCQMasterListTemp: ExamMCQMaster[];
    public pageNumber: number;
    public pageSize: number;
    public timeTakenInSeconds: number;
    public durationLeftInSeconds: number;
    public isExamCompleted: boolean;
    public isCompleted: boolean;
    public entityType: string;
    public type: LookupData;
}